const { getAxiosInstance } = require('../connection');

module.exports = {
    fetchEventQuestions: function (eventId, loadAnswers) {
        return getAxiosInstance({
            url:  '/events/' + encodeURIComponent(eventId) + '/questions' + (loadAnswers ? '?include_answers=true' : ''),
            method: 'GET',
            json: true,
        }).then((response) => response.data);
    },
    postQuestion: function (eventId, askerId, content, anonymous, categoryId, categoryName, attachments) {
        return getAxiosInstance({
            url:  '/events/' + encodeURIComponent(eventId) + '/questions',
            method: 'POST',
            json: true,
            data: {
                event_id: eventId,
                asker_id: askerId,
                content: content,
                anonymous: anonymous,
                category_id: categoryId,
                category: categoryName,
                attachments,
            },
        }).then((response) => response.data);
    },
    updateQuestion: function (eventId, questionId, content, anonymous, attachments) {
        return getAxiosInstance({
            url:  '/events/' + encodeURIComponent(eventId) + '/questions/' + encodeURIComponent(questionId),
            method: 'PUT',
            json: true,
            data: {
                content,
                anonymous,
                attachments,
            },
        }).then((response) => response.data);
    },
    postAnswer: function (questionId, content, anonymous, attachments) {
        return getAxiosInstance({
            url:  '/questions/' + encodeURIComponent(questionId) + '/answers',
            method: 'post',
            json: true,
            data: {
                question_id: questionId,
                content,
                anonymous,
                attachments,
            },
        }).then((response) => response.data);
    },
    deleteQuestion: function (eventId, questionId) {
        return getAxiosInstance({
            url:  '/events/' + encodeURIComponent(eventId) + '/questions/' + encodeURIComponent(questionId),
            method: 'delete',
            json: true,
        }).then((response) => response.data);
    },
    updateAnswer: function (questionId, answerId, content, anonymous, attachments) {
        return getAxiosInstance({
            url:  '/questions/' + encodeURIComponent(questionId) + '/answers/' + encodeURIComponent(answerId),
            method: 'put',
            json: true,
            data: {
                question_id: questionId,
                answer_id: answerId,
                content,
                anonymous,
                attachments,
            },
        }).then((response) => response.data);
    },
    deleteAnswer: function (questionId, answerId) {
        return getAxiosInstance({
            url:  '/questions/' + encodeURIComponent(questionId) + '/answers/' + encodeURIComponent(answerId),
            method: 'delete',
            json: true,
        }).then((response) => response.data);
    },
    fetchAnswers: function (questionId) {
        return getAxiosInstance({
            url:  '/questions/' + encodeURIComponent(questionId) + '/answers',
            method: 'get',
            json: true,
        }).then((r) => r.data);
    },
    joinGroup: function (questionCategoryId) {
        return getAxiosInstance({
            url:  '/subscribed_question_categories',
            method: 'post',
            json: true,
            data: {
                question_category_id: questionCategoryId,
            },
        }).then((r) => r.data);
    },
    leaveGroup: function (questionCategoryId) {
        return getAxiosInstance({
            url:  '/subscribed_question_categories/' + encodeURIComponent(questionCategoryId),
            method: 'delete',
            json: true,
        }).then((r) => r.data);
    },
    favorite: function (questionId, favorite) {
        if (favorite) {
            return getAxiosInstance({
                url:  '/favorites',
                method: 'POST',
                json: true,
                data: {
                    question_id: questionId,
                },
            }).then((r) => r.data);
        } else {
            return getAxiosInstance({
                url:  '/favorites/' + encodeURIComponent(questionId),
                method: 'DELETE',
                json: true,
            }).then((r) => r.data);
        }
    },
    markAsRead: function (eventId) {
        return getAxiosInstance({
            url:  '/events/' + encodeURIComponent(eventId) + '/questions/read',
            method: 'POST',
            json: true,
            data: {
                read: new Date().toISOString().substring(0, 18),
            }
        }).then(r => r.data);
    },
    //copy pasta test
    PostSurvey: function (eventId, askerId, content, anonymous, categoryId, categoryName) {
        return getAxiosInstance({
            url:  '/events/' + encodeURIComponent(eventId) + '/questions',
            method: 'POST',
            json: true,
            data: {
                event_id: eventId,
                asker_id: askerId,
                content: content,
                anonymous: anonymous,
                category_id: categoryId,
                // QUESTION: The category name seems to be used to decide where to store the question (instead of the ID)... WHY?
                category: categoryName,
            },
        }).then((response) => response.data);
    },
};
